import { useState, useEffect } from "react";
import axios from "axios";
import "./Herobanner.css";

function HerobannerLoading() {
  return (
    <section className="herobanner--loading">
      <div className="herobanner__skeleton">
        <div className="shimmer-dark sk-circle" />
        <div className="shimmer-dark sk-title" />
        <div className="shimmer-dark sk-line" />
        <div className="shimmer-dark sk-line sk-line-sm" />
      </div>
    </section>
  );
}

function Herobanner() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);

  const bannerApi = process.env.REACT_APP_HERO_BANNER_API_PATH;
  const backend   = process.env.REACT_APP_BACKEND_LINK;
  const apiKey    = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    axios
      .get(bannerApi, { headers: { Authorization: `Api-Key ${apiKey}` } })
      .then((res) => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [bannerApi, apiKey]);

  if (loading) return <HerobannerLoading />;

  const profileUrl = data?.profile_image?.meta?.download_url
    ? `${backend.replace(/\/$/, "")}${data.profile_image.meta.download_url}`
    : null;

  return (
    <section id="herobanner" className="herobanner">
      <div className="herobanner__inner">
        {profileUrl && (
          <div className="herobanner__avatar">
            <img src={profileUrl} alt="Vasapon profile" />
          </div>
        )}
        <h1 className="herobanner__title">{data?.hero_text || "Hi, I'm Vasapon."}</h1>
        {data?.body && (
          <div
            className="herobanner__body"
            dangerouslySetInnerHTML={{ __html: data.body }}
          />
        )}
      </div>
    </section>
  );
}

export default Herobanner;
